import { useEffect, useState } from 'react'
import '../pages/css/Home.css';
import SecOne from '../images/hero-1.png';
import SecTwo from '../images/about.png';
import SecThree from '../images/bg-1.jpg';
import { motion, useMotionValue, animate } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FaCheckCircle, FaUsers, FaGlobe, FaLock,
  FaRocket,
  FaShieldAlt,
  FaChartLine,
  FaNetworkWired,
  FaHandshake,
  FaHeadset,
  FaWallet,
  FaBolt,
  FaBitcoin,
  FaExchangeAlt,
  FaCoins,
  FaCogs
} from "react-icons/fa"
import { useNavigate } from "react-router-dom";
import Faq from './components/Faq';

function Home() {
const navigate = useNavigate();
  function Counter({ from, to, duration }) {
    const [ref, inView] = useInView({ triggerOnce: false });
    const count = useMotionValue(from);
    const [display, setDisplay] = useState(from);

    useEffect(() => {
      if (inView) {
        const controls = animate(count, to, {
          duration,
          ease: "easeOut",
          onUpdate: (latest) => {
            setDisplay(Math.floor(latest)); // update state on each frame
          },
        });
        return controls.stop; // cleanup
      } else {
        setDisplay(from); // reset when out of view
      }
    }, [inView, count, from, to, duration]);

    return <span ref={ref}>{display.toLocaleString()}</span>;
  }

  const whyUs = [
    {
      Icon: FaRocket,
      title: "Easy to Start",
      desc: "Get started in minutes with seamless onboarding and a user-friendly interface designed for both beginners and experts.",
    },
    {
      Icon: FaShieldAlt,
      title: "Ultra-Secure Blockchain",
      desc: "Powered by next-gen blockchain technology with advanced encryption, ensuring your assets are always safe.",
    },
    {
      Icon: FaChartLine,
      title: "High ROI Over 15 Years",
      desc: "With consistent growth, Starlink Network has outperformed traditional investments, delivering exceptional returns over the last decade.",
    },
    {
      Icon: FaNetworkWired,
      title: "Decentralized & Transparent",
      desc: "Built on a fully decentralized ecosystem, ensuring transparency, security, and no third-party interference.",
    },
    {
      Icon: FaHandshake,
      title: "Backed by Leading Investors",
      desc: "Starlink Network has gained support from top financial institutions and blockchain pioneers, ensuring stability and growth.",
    },
    {
      Icon: FaHeadset,
      title: "24/7 Global Support",
      desc: "Enjoy round-the-clock support from our dedicated team, ensuring smooth transactions and security at all times.",
    },
    {
      Icon: FaGlobe,
      title: "Global Accessibility",
      desc: "Our platform is available worldwide, enabling seamless transactions and investments across borders with multi-currency support.",
    },
    {
      Icon: FaCogs,
      title: "Scalable Solutions",
      desc: "Designed for growth, our infrastructure scales effortlessly to meet increasing demand without compromising performance or security.",
    }
  ];


  const services = [
    {
      Icon: FaWallet,
      title: "Secure Crypto Wallet",
      desc: "Store, send, and receive cryptocurrencies safely with our highly secure digital wallet.",
      // link: "/secure-crypto-wallet"
    },
    {
      Icon: FaBolt,
      title: "Fast & Reliable Transactions",
      desc: "Experience lightning-fast transactions with minimal fees and top-notch security.",
      // link: "/fast-reliable-transactions"
    },
    {
      Icon: FaBitcoin,
      title: "Bitcoin Investment",
      desc: "Grow your wealth by investing in Bitcoin with our expert guidance and secure platform.",
      // link: "/bitcoin-investment"
    },
    {
      Icon: FaExchangeAlt,
      title: "Currency Exchange",
      desc: "Exchange cryptocurrencies seamlessly at competitive rates with our reliable platform.",
      // link: "/currency-exchange"
    },
    {
      Icon: FaLock,
      title: "Bitcoin Escrow Service",
      desc: "Secure your transactions with our trusted escrow service for risk-free crypto trading.",
      // link: "/bitcoin-escrow-service"
    },
    {
      Icon: FaCoins,
      title: "Token Sale & ICO",
      desc: "Invest in the future with our exclusive token sales and Initial Coin Offerings (ICO).",
      // link: "/token-sale-ico"
    }
  ];

  return (
    <>
      <section className="hero-section text-white">
        <div className="container my-5 container-fluid">
          <div className="row align-items-center">
            {/* Left Side */}
            <motion.div
              className="col-md-6 text-center text-md-start mb-4 mb-md-0"
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: false, amount: 0.2 }}
            >
              <h1 className="fw-bold">Trusted <span className="highlight-text">Crypto</span> Company <span className="highlight-text">Since</span> 2015</h1>
              <p className="lead">
                Launched in 2015, our cryptocurrency has grown into a trusted
                digital asset, offering stability, security, and high-value
                potential. With a strong foundation in the US market, we provide
                seamless transactions, cutting-edge security, and an investment
                opportunity that has stood the test of time. Join a future-driven
                network built for success.
              </p>
              <button className="btn custom-orange-btn py-2 px-3 fw-bold"  onClick={() => navigate("/login")}>
                Get Started
              </button>
            </motion.div>

            {/* Right Side */}
            <motion.div
              className="col-md-6 text-center"
              initial={{ x: 100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: false, amount: 0.2 }}
            >
              <motion.img
                src={SecOne}
                alt="Hero"
                className="img-fluid rounded"
                animate={{
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  repeatType: "loop",
                  ease: "easeInOut",
                }} />
            </motion.div>
          </div>
        </div>
      </section>

      <section className="container my-5 container-fluid">
        <div className="row align-items-center g-5">
          <motion.div
            className="col-md-6 text-center"
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.2 }}
          >
            <img
              src={SecTwo}
              alt="Hero"
              className="img-fluid rounded"
              style={{ maxWidth: "85%" }}
            />
          </motion.div>

          <motion.div
            className="col-md-6 text-center text-md-start mb-4 mb-md-0"
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.2 }}
          >
            {/* Heading */}
            <h1 className="fw-bold display-5 text-dark"><span className="highlight-text">About Us</span></h1>

            {/* Subheading */}
            <h5 className="fw-semibold text-muted" style={{ color: "#FF7F50" }}>
              The Most Trusted Cryptocurrency Platform
            </h5>

            {/* Description */}
            <p className="lead mt-3">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo magna dolore erat amet

              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit. Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>

            {/* Tick-marked List */}
            <ul className="list-unstyled mt-3">
              <li className="d-flex align-items-center mb-2">
                <FaCheckCircle className="text-success me-2" /> Stability & Long-Term Value
              </li>
              <li className="d-flex align-items-center mb-2">
                <FaCheckCircle className="text-success me-2" /> Secure & Seamless Transactions
              </li>
              <li className="d-flex align-items-center mb-2">
                <FaCheckCircle className="text-success me-2" /> Trusted by Investors Worldwide
              </li>
            </ul>

            {/* Button */}
            <button className="btn custom-orange-btn py-2 px-3 fw-bold mt-3" onClick={() => navigate("/login")}>
              Get Started
            </button>
          </motion.div>

        </div>
      </section>

      {/* Stats Section */}
      <section className="hero-section container my-5 container-fluid">
        <div className="row text-center">
          {/* Box 1 */}
          <motion.div
            className="col-md-4 mb-4"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false }}
          >
            <FaUsers size={40} className="text-primary mb-3" />
            <h2 className="fw-bold display-5">
              <Counter from={0} to={10000} duration={20} />+
            </h2>
            <p className="text-muted">Active Users</p>
          </motion.div>

          {/* Box 2 */}
          <motion.div
            className="col-md-4 mb-4"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: false }}
          >
            <FaGlobe size={40} className="text-success mb-3" />
            <h2 className="fw-bold display-5">
              <Counter from={0} to={50} duration={20} />+
            </h2>
            <p className="text-muted">Countries Reached</p>
          </motion.div>

          {/* Box 3 */}
          <motion.div
            className="col-md-4 mb-4"
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: false }}
          >
            <FaLock size={40} className="text-warning mb-3" />
            <h2 className="fw-bold display-5">
              <Counter from={0} to={100} duration={20} />%
            </h2>
            <p className="text-muted">Secure Transactions</p>
          </motion.div>
        </div>
      </section>

      <section className="container my-5 container-fluid text-center">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false }}
        >
          <h2 className="fw-bold responsive-heading">Welcome to <span className="highlight-text">Black Stone</span></h2>
          <h5 className="mt-2 text-muted" >The Future of Decentralized Finance with Proven High Returns</h5>
        </motion.div>
      </section>

      <section id="services" className="services-section" style={{ backgroundImage: `url(${SecThree})` }}>
        <motion.section className="container my-5"
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: false, amount: 0.6 }}
          transition={{ duration: 0.8, ease: "easeOut" }}>

        </motion.section>
        <div className="container my-5">
          <div className="row">
            {whyUs.map(({ Icon, title, desc, link }, idx) => (
              <motion.div
                key={idx}
                className="col-12 col-sm-6 col-md-3 mb-4"
                initial={{ x: idx < 4 ? -50 : 50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.8, ease: 'easeOut', delay: idx * 0.2 }}
                style={{ cursor: 'pointer' }}
              // onClick={() => window.open(link, '_blank')}
              >
                <div className="services-card">
                  <Icon size={48} className="services-icon" />
                  <h5 className="fw-bold mb-2">{title}</h5>
                  <p className="mb-0" style={{ fontSize: '14px' }}>
                    {desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

      </section>

      <section
        id="services"
        className="services-section"
      >
        <section className="container my-5 container-fluid text-center">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: false }}
          >
            <h2 className="fw-bold responsive-heading">Our <span className="highlight-text">Services</span></h2>
            <h5 className="mt-2 text-muted" style={{ color: "#FF7F50" }}>Seamless Solutions for Buying, Selling & Exchanging Cryptocurrency</h5>
          </motion.div>
        </section>
        <div className="container my-5">
          <div className="row">
            {services.map(({ Icon, title, desc, link }, idx) => (
              <motion.div
                key={idx}
                className="col-12 col-sm-6 col-md-4 mb-4" // 3 boxes per row
                initial={{ x: idx % 2 === 0 ? -50 : 50, opacity: 0 }} // alternate left-right
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: idx * 0.2 }}
                style={{ cursor: "pointer" }}
              // onClick={() => window.open(link, '_blank')}
              >
                <div className="services-card text-center shadow-lg p-4 h-100">
                  <Icon size={48} className="services-icon mb-3" />
                  <h5 className="fw-bold mb-2">{title}</h5>
                  <p className="mb-0" style={{ fontSize: "14px" }}>
                    {desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Faq />
    </>
  )
}

export default Home